export default "__VITE_ASSET__DXqoJwCI__"